import { f7 } from 'framework7-vue'

export function confirm (title, text, callback) {
  f7.dialog.create({
    title,
    text,
    buttons: [
      {
        text: 'Confirm',
        onClick () { callback && callback() }
      },
      {
        text: 'Cancel',
        cssClass: 'button-cancel'
      }
    ]
  }).open()
}

export function exitApp () {
  window.parent.Turbo.visit('/home', { action: 'replace' })
}
